<template>
        <el-upload
            ref="upload"
            class="upload-demo"
            :action="urlUpload"
            :limit="1"
            :on-exceed="handleExceed"
            :auto-upload="false"
        >
            <template #trigger>
                <el-select v-model="typeDevice" placeholder="Select" style="width: 240px">
                    <el-option label="modem" value="modem" />
                    <el-option label="sensor" value="sensor" />
                </el-select>
                <el-button type="primary">select file</el-button>
            </template>
            <el-button class="ml-3" type="success" @click="updateListFrameware">
                upload to server
            </el-button>
        </el-upload>
        <el-tabs v-model="activeTab" class="demo-tabs" @tab-click="chooseTab">
            <el-tab-pane label="Modem" name="modem">
                <el-table :data="frameWareList">
                    <el-table-column property="date" label="Date" width="150" />
                    <el-table-column property="version" label="Name" width="100" />
                    <el-table-column property="filename" label="200" />
                    <el-table-column property="link_to_file" label="200" />
                    <el-table-column property="size" label="100" />
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="Sensor" name="sensor">
                <el-table :data="frameWareList">
                    <el-table-column property="date" label="Date" width="150" />
                    <el-table-column property="version" label="Name" width="100" />
                    <el-table-column property="filename" label="200" />
                    <el-table-column property="link_to_file" label="200" />
                    <el-table-column property="size" label="100" />
                </el-table>
            </el-tab-pane>
        </el-tabs>
</template>

<script>
import axios from '../../../config-axios'
import { ref } from 'vue'
import { genFileId } from 'element-plus'

import { mapGetters, mapActions } from 'vuex'



export default {
    name: 'VersionWindow',
    computed: {
        ...mapGetters('modem', {
            frameWareList: 'getFrameWareList'
        }),
        urlUpload() {
            return axios.defaults.baseURL+'upload_frameware/'+ '?type=' + this.typeDevice
        }
    },
    props: ['dialogTableVisible'],
    emits: ['hideWindow'],
    data() {
        return {
            isShowWindow: false,
            activeTab: "modem",
            typeDevice: "modem",
            gridData: [
                {
                    date: 123,
                    name: 321,
                    address: 567
                }
            ]
        }
    },
    watch: {
    },
    setup() {
        const upload = ref(null)

        const handleExceed = (files) => {
            upload.value.clearFiles()
            const file = files[0]
            file.uid = genFileId()
            upload.value.handleStart(file)
        }

        const submitUpload = () => {
            upload.value.submit()
        }

        return {
            upload,
            handleExceed,
            submitUpload
        }
    },
    methods: {
        ...mapActions('modem', {
            getFrameWareList: 'getApiFrameWareList',
        }),
        chooseTab(tab, event) {
            
            this.getFrameWareList(tab.props.name)
        },
        updateListFrameware() {
            this.submitUpload()
            this.getFrameWareList(this.activeTab)
        }
    },
    created() {
        this.getFrameWareList(this.activeTab)
    }
}

</script>

<style scoped lang="scss">
.upload-demo {
    display: flex;

    .el-select {
        margin-right: 10px;
    }
    
    .ml-3 {
        margin-left: 30px;
    }
}

</style>